import store from '@/store'
import Vue from 'vue'
import VueRouter, { Route } from 'vue-router'
import { Route as StoreRoute, Modal } from '@/models'
import routes from '@/router/routes'
import { ActionTypes } from '@/store/action-types'
import { MutationTypes } from '@/store/mutation-types'
import Utils from '@/utils'

const getPathFromRoutes = (
  routes: StoreRoute[],
  toPath: string
): StoreRoute | undefined => {
  const route = routes.find(({ path }) => path === toPath)
  return route
}

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  linkActiveClass: 'active',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to: Route, from: Route, next: Function) => {
  // First thing is to check if user is authenticated
  if (to.meta && to.meta.requiresAuth && !store.getters.isUserAuthenticated) {
    // Show modal only if not going to login and redirect from /
    // which means the user tried to navigate to a protected path
    if (to.path !== '/login' && to.redirectedFrom !== '/') {
      const modal: Modal = {
        show: true,
        title: 'Alerta',
        message: 'Debe hacer login para acceder',
        type: 'danger'
      }
      store.commit(MutationTypes.SET_MODAL, modal)
    }
    next({
      name: 'Login',
      params: {
        to: to.fullPath
      }
    })
    return
  }

  // TODO Add user group validation

  if (to.meta && to.meta.toHistory) {
    // add new route to store state:
    const newRoutes = store.getters.lastRoutes
    const path = getPathFromRoutes(store.getters.lastRoutes, to.path)
    const date = Utils.dateToCleanISOFormat(new Date())
    if (path) {
      path.date = date
    } else {
      newRoutes.unshift({ title: document.title, path: to.path, date: date })
    }
    store.dispatch(ActionTypes.STORE_ROUTES, newRoutes)
  }

  if (to.name === 'Login' && store.getters.isUserAuthenticated) {
    next({ name: 'Home' })
  }

  next()
})

export default router
